// extracted by mini-css-extract-plugin
export default {"newproject_container":"Newproject_newproject_container__QTcsb"};